import {push} from 'connected-react-router';

import {buildRequest} from '../stateUtil';
import {
  GET_MANAGER_INSIGHTS_REQUEST,
  GO_TO_MANAGER_INSIGHTS_CONTENT_PERFORMANCE_PAGE,
  GO_TO_MANAGER_INSIGHTS_LEARNER_PERFORMANCE_PAGE,
  GO_TO_MANAGER_INSIGHTS_TEAMS_PAGE,
  GO_TO_MANAGER_INSIGHTS_TRAINING_PAGE,
  RESET_OTP_ERROR,
  SET_MANAGER_INSIGHTS_SELECTED_STORE,
} from './managerInsightsActionTypes';

export const getManagerInsights =
  ({managerId, insightId, token}) =>
  (dispatch) => {
    const requestAction = buildRequest(
      GET_MANAGER_INSIGHTS_REQUEST,
      'GET',
      `/managerInsights/${managerId}/${insightId}?token=${token}`
    );

    return dispatch(requestAction);
  };

export const selectStoreForManagerInsights = (storeId) => (dispatch) =>
  dispatch({
    type: SET_MANAGER_INSIGHTS_SELECTED_STORE,
    payload: {storeId},
  });

export const goToManagerInsightsHome =
  ({insightId, managerId}) =>
  (dispatch) => {
    dispatch(push(`/mi/${managerId}/${insightId}/`));
  };

export const goToManagerInsightsTeamPerformance =
  ({insightId, managerId}) =>
  (dispatch) => {
    dispatch(push(`/mi/${managerId}/${insightId}/team-performance`));
    dispatch({
      type: GO_TO_MANAGER_INSIGHTS_TEAMS_PAGE,
    }); // Needed for Amplitude
  };

export const goToManagerInsightsAssignedTraining =
  ({insightId, managerId}) =>
  (dispatch) => {
    dispatch(push(`/mi/${managerId}/${insightId}/assigned-training`));
    dispatch({
      type: GO_TO_MANAGER_INSIGHTS_TRAINING_PAGE,
    }); // Needed for Amplitude
  };

export const goToManagerInsightsUserDetail =
  ({insightId, managerId, uid}) =>
  (dispatch) => {
    dispatch(push(`/mi/${managerId}/${insightId}/user-detail/${uid}`));
    dispatch({
      type: GO_TO_MANAGER_INSIGHTS_LEARNER_PERFORMANCE_PAGE,
      payload: {uid},
    }); // Needed for Amplitude
  };

export const goToManagerInsightsContentDetail =
  ({insightId, managerId, cid, contentType}) =>
  (dispatch) => {
    dispatch(push(`/mi/${managerId}/${insightId}/content-detail/${cid}`));
    dispatch({
      type: GO_TO_MANAGER_INSIGHTS_CONTENT_PERFORMANCE_PAGE,
      payload: {cid, contentType},
    }); // Needed for Amplitude
  };

export const resetOtpError = () => (dispatch) =>
  dispatch({type: RESET_OTP_ERROR});
